module.exports = __webpack_public_path__ + "static/img/TA600.ae6bf5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/problem/TA600.png
// module id = 9Jnk
// module chunks = 0